import {
    ElementTypes,
    ElementValidations,
    Action,
    ListDefaults,
    ColumnType,
    FilterType,
    GenerateToolBars,
    DefaultPagination
} from '../../config';

import CarrierConfig from '../Carrier/config';

const Truck = {
    Title: 'Truck',
    Resource: 'Truck',
    Master: 'number',
    Key: 'id',
    IsRest: true,
    List: {
        Defaults: ListDefaults,
        ShowRefreshButton: true,
        Search: '_all',
        Filter: {
            number: {
                Type: FilterType.Text,
                Title: 'Number'
            },
            carrierId: {
                Type: FilterType.Select,
                Valuelist: '/api/Carrier/valuelist',
                Title: 'Carrier Name'
            },
            licensePlate: {
                Type: FilterType.Text,
                Title: 'License Plate'
            },
            vinNumber: {
                Type: FilterType.Text,
                Title: 'VIN'
            }
        },
        Pagination: DefaultPagination,
        Columns: {
            number: {
                Title: 'Number',
                Type: ColumnType.Text,
                LinkAppPage: true,
                Sorted: 'ascend',
                DataTitle: false,
                Width: 150
            },
            carrierName: {
                Title: 'Carrier Name',
                Type: ColumnType.Text,
                Width: 150
            },
            vinNumber: {
                Type: ColumnType.Text,
                Title: 'VIN',
                Width: 150
            },
            licensePlate: {
                Title: 'License Plate',
                Type: ColumnType.Text,
                Width: 150
            },
            comment: {
                Title: 'Comment',
                Type: ColumnType.Text,
                Width: 250
            }
        },
        Actions: {
            Width: 60,
            Items: [
                Action.Delete
            ]
        }
    },
    Form: {
        SectionGroups: [
            {
                Sections: [
                    {
                        Fields: {
                            carrierId: {
                                Title: 'Carrier',
                                //Field: ElementTypes.ComboAdd('/api/carrier/valueList', {
                                //    TitlePrefix: '',
                                //    PopupConfig: CarrierConfig
                                //}),
                                Field: ElementTypes.Generic(ElementTypes.ComboAdd, {
                                    dataSource: '/api/carrier/valueList',
                                    addparams: {
                                        TitlePrefix: '',
                                        PopupConfig: CarrierConfig
                                    },
                                    selectedValueType: 'carrierName'
                                }),
                                Validations: [ElementValidations.Required()]
                            },
                            number: {
                                Title: 'Number',
                                Field: ElementTypes.TextField(),
                                Validations: [ElementValidations.Required(), ElementValidations.IntPositiveField()]
                            },
                            vinNumber: {
                                Title: 'VIN',
                                Field: ElementTypes.TextField(),
                                Attributes: {
                                    input: {
                                        maxLength: 17
                                    }
                                },
                                Validations: [ElementValidations.Required(), ElementValidations.NoEmptySpace()]
                            },
                            licensePlate: {
                                Title: 'License Plate',
                                Field: ElementTypes.TextField(),
                                Attributes: {
                                    input: {
                                        maxLength: 20
                                    }
                                },
                                Validations: [ElementValidations.Required()]
                            },
                            comment: {
                                Title: 'Comment',
                                Field: ElementTypes.Comment()
                            }
                        }
                    }
                ]
            }
        ],
        ToolBars: GenerateToolBars()
    }
}; 

export default Truck;